/**
 * Interactive Parking Map
 *
 * Called by Google's Maps JS API script as its `callback` once loaded
 * (see inc/enqueue.php). Reads window.sofAirportParkingMapData, localized
 * server-side by wp_localize_script — already filtered/escaped, so this
 * file just wires up the map, markers and info windows.
 *
 * If this function is never called (script blocked, invalid key, network
 * failure), the #parking-map canvas simply stays hidden — see the
 * `display:none` default in styles.css, only lifted by the `.is-ready`
 * class added on success below (AC4: no broken/blank box on failure).
 */
/**
 * Google's own global callback for auth-specific failures (invalid/
 * restricted key, billing disabled — the "InvalidKeyMapError" case).
 * Pings the server once per pageview so it can email an alert; the
 * server itself rate-limits so a spike of visitors on a broken key
 * doesn't flood the inbox.
 */
window.gm_authFailure = function () {
    if (window.sofAirportMapsAuthFailureReported) {
        return;
    }
    window.sofAirportMapsAuthFailureReported = true;

    jQuery.post('/wp-admin/admin-ajax.php', { action: 'sof_maps_auth_failure' });
};

window.initSofiaAirportParkingMap = function () {
    try {
        var canvas = document.getElementById('parking-map');
        var locations = window.sofAirportParkingMapData || [];

        if (!canvas || !locations.length) {
            return;
        }

        var bounds = new google.maps.LatLngBounds();
        var map = new google.maps.Map(canvas, {
            center: { lat: locations[0].lat, lng: locations[0].lng },
            zoom: 15
        });
        var infoWindow = new google.maps.InfoWindow();

        locations.forEach(function (location) {
            var position = { lat: location.lat, lng: location.lng };
            var marker = new google.maps.Marker({
                position: position,
                map: map,
                title: location.name
            });

            bounds.extend(position);

            marker.addListener('click', function () {
                var content = '<div class="parking-map__info"><strong>' + location.name + '</strong>';
                content += location.descriptionHtml || '';
                content += location.linkHtml || '';
                content += '</div>';

                infoWindow.setContent(content);
                infoWindow.open(map, marker);
            });
        });

        map.fitBounds(bounds);

        canvas.classList.add('is-ready');
    } catch (error) {
        // Section stays hidden (no .is-ready class added) — log for debugging only.
        console.error('Sofia Airport parking map failed to initialize:', error);
    }
};
